import * as XLSX from "xlsx";
import { createPDFFile } from "./checkReportPDF";

export function createCheckWorkbook(snapshot) {
    const data = [["FS ProductID", "Field", "Front Systems", "Incoming", "Difference", "FS source token", "Incoming source token", "Qualification"]];
    for (const product of snapshot.products) {
        for (const row of product.rows) data.push([product.productID, row.label, row.before, row.incoming, row.difference,
            row.beforeToken ?? "", row.incomingToken ?? "", row.note]);
    }
    const context = [...snapshot.header.map(value => [value]), ...snapshot.limitations.map(value => [`Limitation: ${value}`])];
    if (!snapshot.products.length) context.push([snapshot.emptyMessage]);
    for (const rows of [data, context]) {
        if (rows.length > 1048576 || rows.some(row => row.some(value => String(value).length > 32767))) throw Error("CHECK_REPORT_EXCEL_CELL_OR_ROW_LIMIT");
    }
    const book = XLSX.utils.book_new();
    // All monetary values/source tokens remain text, including long exact decimals.
    XLSX.utils.book_append_sheet(book, XLSX.utils.aoa_to_sheet(data), "CHECK differences");
    XLSX.utils.book_append_sheet(book, XLSX.utils.aoa_to_sheet(context), "Context and limitations");
    return book;
}
export function createExcelFile(snapshot) {
    const bytes = XLSX.write(createCheckWorkbook(snapshot), { type: "array", bookType: "xlsx" });
    return new File([bytes], "Front-Systems-CHECK.xlsx", { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
}
export async function prepareCheckFiles(snapshot) {
    const excel = createExcelFile(snapshot), pdf = await createPDFFile(snapshot);
    return { excel, pdf };
}
export function downloadCheckFile(file) {
    let url, link;
    try {
        url = URL.createObjectURL(file); link = document.createElement("a");
        link.href = url; link.download = file.name; document.body.appendChild(link); link.click();
    } finally { link?.remove(); if (url) setTimeout(() => URL.revokeObjectURL(url), 1000); }
}
export function checkEmailMessage(snapshot, pdfAvailable = false) {
    return `${snapshot.subject}\n${snapshot.header.join("\n")}\nFiltered ProductIDs: ${snapshot.products.length}${snapshot.products.length ? "" : `\n${snapshot.emptyMessage}`}\n${pdfAvailable
        ? "Add the downloaded Excel and PDF attachments manually." : "Add the downloaded Excel attachment manually. PDF is unavailable in this build."} Review before sending; no message has been sent.`;
}
